import { z } from 'zod';
import {
  address1Schema,
  address2Schema,
  citySchema,
  optionalEmailSchema,
  optionalPhoneNumberSchema,
  stateSchema,
  zipCodeSchema,
} from './validation-utils.ts';

// Shipping address schema - similar to locationAddressSchema but without required name and dealerId
export const addressSchema = z.object({
  address1: address1Schema,
  address2: address2Schema.optional().nullable(),
  city: citySchema,
  state: stateSchema,
  zip: zipCodeSchema,
  phone: optionalPhoneNumberSchema.optional().nullable(),
  fax: optionalPhoneNumberSchema.optional().nullable(),
  email: optionalEmailSchema.optional().nullable(),
});

// Reusable Zod schema for Location Address - extends addressSchema with additional fields
export const locationAddressSchema = addressSchema.extend({
  id: z.number().optional(),
  dealerId: z.number(),
  name: z.string().min(2, 'Name is required').max(250, 'Name is too long'),
});
